(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiree671"];
var parcelRegister = parcelRequire.register;
parcelRegister("5QPEU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4429e176f43538de$export$2e2bcd8739ae039; });
var $4429e176f43538de$var$Numbers = {
    init: function() {
        var scrollingNumbers = [].slice.call(document.querySelectorAll(".countable"));
        scrollingNumbers.forEach(function(element) {
            $4429e176f43538de$var$Numbers.numbersObserver.observe(element);
        });
    },
    animateValue: function(obj) {
        var end = parseInt(obj.dataset.end, 10);
        var current = 0;
        var increment = end / 8;
        var stepTime = 80;
        var objNr = obj.querySelector("span");
        var timer = setInterval(function() {
            current += increment;
            objNr.innerHTML = current.toFixed(0).toString();
            if (current > end) {
                objNr.innerHTML = end.toLocaleString("et-EE");
                clearInterval(timer);
            }
        }, stepTime);
    },
    numbersObserver: new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                $4429e176f43538de$var$Numbers.animateValue(entry.target);
                entry.target.parentElement.classList.add("counted");
                $4429e176f43538de$var$Numbers.numbersObserver.unobserve(entry.target);
            }
        });
    })
};
var $4429e176f43538de$export$2e2bcd8739ae039 = $4429e176f43538de$var$Numbers;

});

})();
//# sourceMappingURL=numbers.971d1051.js.map
